import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage';
import { UserProfile } from '../../../models/user-profile.model';
import { UtilService } from '../../../service/util.service';
import { ReportService } from '../report.service';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { RoleAccess } from '../../../models/role-access.model';
import { UserData } from '../../../providers/user-data';
import { NavigationExtras, Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { ReportRekapPromoComponent } from '../../../component/advanced-filter/report-rekap-promo/report-rekap-promo.component';

import { AES } from 'crypto-js';
import { environment } from '../../../../environments/environment';
import { ReportPromoType } from '../../../enum/ReportCashierType';
import { ReportCashierBranchListComponent } from '../../../component/report-cashier-branch-list/report-cashier-branch-list.component';
import { ShowMoreComponent } from '../../../component/show-more/show-more.component';
@Component({
  selector: 'app-rekap-promo',
  templateUrl: './rekap-promo.page.html',
  styleUrls: ['./rekap-promo.page.scss'],
})
export class RekapPromoPage implements OnInit {
  token: any;
  userProfile: UserProfile = new UserProfile();
  userAccess: any[] = [];
  reportData:any[]=[];
  branchName:string='';
  counterName:string='';
  dateStart:any='';
  dateEnd:any='';
  branchData: any[] = [];
  counterData: any[] = [];
  roleAccess = new RoleAccess();
  fileName= 'Rekap_Promo.xlsx';
  showBtnCounterList: boolean = false;
  showBtnBranchList: boolean = false;
  counterListForShow: any[] = [];
  branchListForShow:any[] =[];
  idBranch: any= 'null';
  idCounter: any = 'null';
  paramBranchId: any;
  paramCounterId: any;
  paramPeriodStart: any;
  paramPeriodEnd: any;
  paramStatus:any;
  status:number=2;
  statusName:string='Semua';
  listStatus: any[] = ['Not Active','Active',  'All'];
  rekapPer:any='0';
  ReportPromoLabels: Record<ReportPromoType, string> = {
    [ReportPromoType.Status]: "Status Promo",
    [ReportPromoType.Pemakaian]: "Pemakaian By Nama Promo",
    [ReportPromoType.PromoType]: "Pemakaian By Tipe Promo"
  };
  typeReport = ReportPromoType;
  typeReportList = Object.keys(ReportPromoType).filter(key => isNaN(Number(key))) as (keyof typeof ReportPromoType)[];
  rekapPerName ='';
  promotionType ='';
  promotionTypeName = '';
  promotionTypeData : any[];
  constructor(
    private storage: Storage,
    private utilService:UtilService,
    private reportService: ReportService,
    private toastCtrl:ToastController,
    private router: Router,
    private userDataProvider: UserData,
    private modalController:ModalController,
    private navCtrl:NavController
  ) { }

  ngOnInit() {
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userAccess = access;
        this.utilService.loadingPresent('Harap tunggu...')
        .then(() => {
          this.userProfile = new UserProfile(profile);
          let counterId = this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list;
          let options = { 
            "token": this.token,
            "counter_id": counterId
          };
          this.reportService.getReportCashierIndex(options).subscribe((response) => {
            this.utilService.loadingDismiss();
            this.branchData = response.results.branch_data;
            this.counterData = response.results.counter_data;
            this.promotionTypeData = response.results.promotion_type_data;
            this.roleAccess = this.userDataProvider.checkAccess(this.router.url, this.userAccess, this.userProfile);
            let branchId='';
            if(this.branchData.length>0){
              for(let i = 0; i < this.branchData.length; i++) {
                if(branchId === '') {
                  branchId = this.branchData[i].id;
                } else {
                  branchId = branchId + ', ' + this.branchData[i].id;
                }
              }
            }
            this.generateReport(branchId,counterId, new Date(), new Date(),this.status,'0');
          }, () => {
            this.utilService.loadingDismiss();
            this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
          });
        });
      }
    });
  }
  generateReport(branchId:any,counterId: any, periodStart: any, periodEnd: any,status:number,rekapPer:any) {
    this.rekapPerName =this.ReportPromoLabels[rekapPer];// this.typeReportList[rekapPer];
    let startDate = new Date(periodStart);
    let endDate = new Date(periodEnd);
    let convertDateStart = this.utilService.convertDate(startDate);
    let convertDateEnd = this.utilService.convertDate(endDate);
    this.dateStart = convertDateStart.years + '-' + convertDateStart.months + '-' + convertDateStart.dates;
    this.dateEnd = convertDateEnd.years + '-' + convertDateEnd.months + '-' + convertDateEnd.dates;
    this.idBranch = branchId !== 'undefined' && branchId !== '' ? branchId : 'null';
    this.idCounter = counterId !== 'undefined' && counterId !== '' ? counterId : 'null';

    this.paramPeriodStart = periodStart;
    this.paramPeriodEnd = periodEnd;
    this.paramBranchId = branchId;
    this.paramCounterId = counterId;
    this.paramStatus=status;
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let options = {
        "token": this.token,
        "start_date": this.dateStart,
        "end_date": this.dateEnd,
        "branch_id":this.idBranch,
        "counter_id": this.idCounter,
        "promotion_type":this.promotionType,
        "status":status
      };
      this.reportData=[];
      if(rekapPer=='0'){
        this.reportService.getReportRekapPromo(options).subscribe((response) => {
          this.utilService.loadingDismiss();
          if(response.status.code === 200) {
            this.counterListForShow = response.counter_data;
            this.branchListForShow = response.branch_data;
            this.reportData = response.results;
            this.branchData =this.branchListForShow;
            this.statusName=this.listStatus[status];
            if(this.counterListForShow.length > 0) {
              let loopCounter = 0;
              if(this.counterListForShow.length > 5) {
                loopCounter = 5;
                this.showBtnCounterList = true;
              } else {
                loopCounter = this.counterListForShow.length;
                this.showBtnCounterList = false;
              }
              this.counterName = '';
              for(let i = 0; i < loopCounter; i++) {
                if(this.counterName === '') {
                  this.counterName = this.counterListForShow[i].counter_name;
                } else {
                  this.counterName = this.counterName + ', ' + this.counterListForShow[i].counter_name;
                }
              }
            } else {
              this.counterName = 'Data Not Found';
            }
            if(this.branchListForShow.length > 0) {
              let loopBranch = 0;
              if(this.branchListForShow.length >5) {
                loopBranch = 5;
                this.showBtnBranchList = true;
              } else {
                loopBranch = this.branchListForShow.length;
                this.showBtnBranchList = false;
              }
              this.branchName = '';
              for(let i = 0; i < loopBranch; i++) {
                if(this.branchName === '') {
                  this.branchName = this.branchListForShow[i].branch_name;
                } else {
                  this.branchName = this.branchName + ', ' + this.branchListForShow[i].branch_name;
                }
              }
            } else {
              this.showBtnBranchList = false;
              this.branchName = 'Data Not Found';
            }
          } else {
            this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
          }
        }, (err) => {
          this.utilService.loadingDismiss();
          console.log(err);
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        });
      }
      else if(rekapPer=='1'){
          this.utilService.loadingDismiss();
          this.reportService.getReportPemakaianPromo(options).subscribe((response)=>{
          if(response.status.code===200){
            let promotionTypeSplit = this.promotionType !== '' ? String(this.promotionType).split(',') : [];
            this.promotionTypeName = '';
            if(promotionTypeSplit.length>0){
               for(let i= 0; i < promotionTypeSplit.length; i++) {
                let selectedPromotionType: any = this.promotionTypeData.find(x => x.id ==  promotionTypeSplit[i]);
                if(selectedPromotionType){
                  let idx =this.promotionTypeData.indexOf(selectedPromotionType);
                  this.promotionTypeName+=(this.promotionTypeData[idx].promotion_type_name+', ');
                }
              }
            }
            this.reportData = response.results;
            this.countTotalReportPemakaianPromo(this.reportData);
          }
          else{
            this.toastCtrl.create({duration:2000, message:'Gagal terhubung ke server'})
          }
        }, (err)=>{
          console.log(err);
          this.toastCtrl.create({duration:2000, message:'Gagal terhubung ke server'})
        })
      }
      else if(rekapPer=='2'){
          this.utilService.loadingDismiss();
          this.reportService.getReportPemakaianPromo(options).subscribe((response)=>{
          if(response.status.code===200){
            let promotionTypeSplit = this.promotionType !== '' ? String(this.promotionType).split(',') : [];
            this.promotionTypeName = '';
            if(promotionTypeSplit.length>0){
              for(let i= 0; i < promotionTypeSplit.length; i++) {
                let selectedPromotionType: any = this.promotionTypeData.find(x => x.id ==  promotionTypeSplit[i]);
                if(selectedPromotionType){
                  let idx =this.promotionTypeData.indexOf(selectedPromotionType);
                  this.promotionTypeName+=(this.promotionTypeData[idx].promotion_type_name+', ');            
                }
              }
            }
            this.reportData = response.results;
            this.countTotalReportPemakaianPromoType(this.reportData);
          }
          else{
            this.toastCtrl.create({duration:2000, message:'Gagal terhubung ke server'})
          }
        }, (err)=>{
          console.log(err);
          this.toastCtrl.create({duration:2000, message:'Gagal terhubung ke server'})
        })
      }
    });
  }

  countTotalReportPemakaianPromo(report: any) {
    let promotionId: any = '';
    let promotionName  = '';
    let sumDiscount =0;
    let sumFreeItem =0;
    let arrSum = [];
    let sumNetto = 0;
    let receiptNo = '';
    report.sort(function(a, b) {
      var textA = a.promotion_name.toUpperCase();
      var textB = b.promotion_name.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    let insertedSum = 0;
    for(let i = 0; i < report.length; i++) {
      let tempPromotionId = report[i].promotion_id;
      promotionName = report[i].promotion_name;
      let tempReceiptNo = report[i].receipt_no;
      report[i]['no']=i+1;
      if(i === 0) {
        receiptNo = tempReceiptNo;
        sumFreeItem = 0; sumDiscount = 0;
        sumDiscount = sumDiscount + parseInt(report[i].discount);
        sumFreeItem = sumFreeItem + parseInt(report[i].qty_free_item);
        sumNetto = sumNetto + parseInt(report[i].total_value);
        let data = {
          'id':'0',
          index_insert: i+1,
          'promotion_id':tempPromotionId,
          'promotion_name':promotionName,
          'sum_free_item':sumFreeItem,
          'sum_discount':sumDiscount,
          'sum_netto':sumNetto
        }
        insertedSum++;
        arrSum.push(data);
      }
      else{
        if(receiptNo==tempReceiptNo){
          report[i].total_value=0;
        }
        else{
          receiptNo = tempReceiptNo;
        }
      }
      if(promotionId === tempPromotionId) {
        sumDiscount = sumDiscount + parseInt(report[i].discount);
        sumFreeItem = sumFreeItem + parseInt(report[i].qty_free_item);
        sumNetto = sumNetto + parseInt(report[i].total_value);
        let cariSum = arrSum.find(x=>x.promotion_id==promotionId);
        if(cariSum){
          let indexSum = arrSum.indexOf(cariSum);
          arrSum[indexSum]['index_insert'] = i+insertedSum;
          arrSum[indexSum]['sum_free_item'] = sumFreeItem;
          arrSum[indexSum]['sum_discount'] = sumDiscount;
          arrSum[indexSum]['sum_netto'] = sumNetto;
        }
      } else {
        sumFreeItem = 0; sumDiscount = 0;
        sumNetto = 0;
        sumDiscount = sumDiscount + parseInt(report[i].discount);
        sumFreeItem = sumFreeItem + parseInt(report[i].qty_free_item);
        sumNetto = sumNetto + parseInt(report[i].total_value);
        //end new sum for next promotion
        promotionId = tempPromotionId;
        let cariSum = arrSum.find(x=>x.promotion_id==promotionId);
        if(!cariSum){
          insertedSum++;
          let data = {
            'id':'0',
            index_insert: i+insertedSum,
            'promotion_id':promotionId,
            'promotion_name':promotionName,
            'sum_free_item':sumFreeItem,
            'sum_discount':sumDiscount,
            'sum_netto':sumNetto,
          }
          arrSum.push(data);
        }
      }
    }
    for(let x = 0; x < arrSum.length; x++) {
      let indexInsert: number = arrSum[x].index_insert;
      this.reportData.splice(indexInsert, 0, arrSum[x]);
    }
  }
  countTotalReportPemakaianPromoType(report: any) {
    let promotionTypeId: any = '';
    let promotionTypeName  = '';
    let sumDiscount =0;
    let sumFreeItem =0;
    let arrSum = [];
    let sumNetto = 0;
    report.sort(function(a, b) {
      var textA = a.promotion_type_name.toUpperCase();
      var textB = b.promotion_type_name.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    let insertedSum = 0;
    let receiptNo = '';
    for(let i = 0; i < report.length; i++) {
      let tempPromotionTypeId = report[i].promotion_type_id;
      promotionTypeName = report[i].promotion_type_name;
      let tempReceiptNo = report[i].receipt_no;
      report[i]['no']=i+1;
      if(i === 0) {
        receiptNo = tempReceiptNo;
        sumFreeItem = 0; sumDiscount = 0;
        sumNetto = 0;
        sumDiscount = sumDiscount + parseInt(report[i].discount);
        sumFreeItem = sumFreeItem + parseInt(report[i].qty_free_item);
        sumNetto = sumNetto + parseInt(report[i].total_value);
        let data = {
          'id':'0',
          index_insert: i+1,
          'promotion_id':tempPromotionTypeId,
          'promotion_name':promotionTypeName,
          'sum_free_item':sumFreeItem,
          'sum_discount':sumDiscount,
          'sum_netto':sumNetto
        }
        insertedSum++;
        arrSum.push(data);
      }
      else{
        if(receiptNo==tempReceiptNo){
          report[i].total_value=0;
        }
        else{
          receiptNo = tempReceiptNo;
        }
      }
      if(promotionTypeId === tempPromotionTypeId) {
        sumDiscount = sumDiscount + parseInt(report[i].discount);
        sumFreeItem = sumFreeItem + parseInt(report[i].qty_free_item);
        sumNetto = sumNetto + parseInt(report[i].total_value);
        let cariSum = arrSum.find(x=>x.promotion_id==promotionTypeId);
        if(cariSum){
          let indexSum = arrSum.indexOf(cariSum);
          arrSum[indexSum]['index_insert'] = i+insertedSum;
          arrSum[indexSum]['sum_free_item'] = sumFreeItem;
          arrSum[indexSum]['sum_discount'] = sumDiscount;
          arrSum[indexSum]['sum_netto'] = sumNetto;
        }
      } else {
        sumFreeItem = 0; sumDiscount = 0;sumNetto =0;
        sumDiscount = sumDiscount + parseInt(report[i].discount);
        sumFreeItem = sumFreeItem + parseInt(report[i].qty_free_item);
        sumNetto = sumNetto + parseInt(report[i].total_value);
        //end new sum for next promotion
        promotionTypeId = tempPromotionTypeId;
        let cariSum = arrSum.find(x=>x.promotion_id==promotionTypeId);
        if(!cariSum){
          insertedSum++;
          let data = {
            'id':'0',
            index_insert: i+insertedSum,
            'promotion_id':promotionTypeId,
            'promotion_name':promotionTypeName,
            'sum_free_item':sumFreeItem,
            'sum_discount':sumDiscount,
            'sum_netto':sumNetto
          }
          arrSum.push(data);
        }
      }
    }
    for(let x = 0; x < arrSum.length; x++) {
      let indexInsert: number = arrSum[x].index_insert;
      this.reportData.splice(indexInsert, 0, arrSum[x]);
    }
  }
  exportToExcel() {
    let element = document.getElementById('excel-table');
    this.fileName = 'Rekap_Promo.xlsx';
    if (this.rekapPer === '1' || this.rekapPer=='2') {
      element = document.getElementById('excel-table-pemakaian');
      this.fileName = 'Report Pemakaian Promo.xlsx';
    }
    if (element) {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      // ➕ Tambahkan auto-width
      const range = XLSX.utils.decode_range(ws['!ref']!);
      const colWidths: Array<{ wch: number }> = [];
      for (let C = range.s.c; C <= range.e.c; ++C) {
        let maxWidth = 10; // default width
        for (let R = range.s.r; R <= range.e.r; ++R) {
          const cellAddress = { c: C, r: R };
          const cellRef = XLSX.utils.encode_cell(cellAddress);
          const cell = ws[cellRef];
          if (cell && cell.v != null) {
            const cellValue = String(cell.v);
            maxWidth = Math.max(maxWidth, cellValue.length);
          }
        }
        colWidths.push({ wch: maxWidth + 2 }); // tambah padding
      }
      ws['!cols'] = colWidths; // ← ini yang membuat kolom auto width
      // Buat dan simpan workbook
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, this.fileName);
    } else {
      console.error('Tabel tidak ditemukan.');
    }
  }

  async openAdvancedFilters() {
    const modal = await this.modalController.create({
      component: ReportRekapPromoComponent,
      componentProps: {
        branchList: this.branchData,
        counterList: this.counterData,
        paramBranchId: this.paramBranchId,
        paramCounterId: this.paramCounterId,
        paramPeriodStart: this.paramPeriodStart,
        paramPeriodEnd: this.paramPeriodEnd,
        paramStatus : this.paramStatus,
        paramRekapPer:this.rekapPer,
        paramPromotionType:this.promotionType
      },
      backdropDismiss: false
    });

    modal.onDidDismiss().then((modelData) => {
      let data = modelData.data;
      if (data !== 'null') {
        let splitData = data.split('#');
        this.rekapPer = splitData[5];
        this.promotionType = splitData[6];
        this.generateReport(splitData[0],splitData[1], splitData[2], splitData[3],splitData[4],splitData[5]);
      }
    });
    return await modal.present();
  }

  goToDetail(id: any) {
    id=parseInt(id);
    let myKey = environment.myKey;
    let encryptID = AES.encrypt(JSON.stringify(id),myKey).toString();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        i: encryptID
      }
    };
    this.navCtrl.navigateForward(['/promotions/promotion-detail'], navigationExtras);
  }
  async showBranchList() {
    const modal = await this.modalController.create({
      component: ReportCashierBranchListComponent,
      componentProps: {
        branchList: this.branchListForShow
      },
      backdropDismiss: false
    });

    modal.onDidDismiss().then((modelData) => {
      let data = modelData.data;

      if (data !== 'null') {
        //
      }
    });

    return await modal.present();
  }
  async showCounterList() {
    let tableHeader = ['Kode Outlet','Nama']
    let tableContent = [];
    if( this.counterListForShow.length>0){
      for(let i=0;i<this.counterListForShow.length;i++){
        let counter_name = this.counterListForShow[i].counter_name;
        let counter_code = this.counterListForShow[i].counter_code;
        tableContent.push([counter_code,counter_name]);
      }
    }
    const modal = await this.modalController.create({
      component: ShowMoreComponent,
      componentProps: {
        title:'List Counter',
        tableHeader:tableHeader,
        tableContent:tableContent
      },
      backdropDismiss: false
    });
    return await modal.present();
  }
}
